import {
  publicHolidayColor,
  blackFont,
  sickColor,
  holidayColor,
  defaultBorderColor,
  otherColor,
  workdayColor,
  nonWorkdayColor,
} from './colorConfig';
import { Employee } from '~/common/entities/Department/DepartmentTypes';
import { TableCellProps, Td } from '@chakra-ui/react';
import { useTimetrackingStore } from './utils';
import { isSameDay } from 'date-fns';
import { useMemo } from 'react';

export type DayStatus =
  | 'WORKDAY'
  | 'NON_WORKDAY'
  | 'PUBLIC_HOLIDAY'
  | 'SICK'
  | 'HOLIDAY'
  | 'OTHER';

type Props = {
  employee: Employee;
  day: Date;
  dayStatus: DayStatus;
  name: string;
};

export const DayData = ({ employee, day, dayStatus, name }: Props) => {
  const { selectDay, selectedDays } = useTimetrackingStore();

  const [backgroundColor, color] = useMemo(() => {
    switch (dayStatus) {
      case 'PUBLIC_HOLIDAY':
        return [publicHolidayColor, blackFont];
      case 'SICK':
        return [sickColor, blackFont];
      case 'HOLIDAY':
        return [holidayColor, blackFont];
      case 'OTHER':
        return [otherColor, blackFont];
      case 'WORKDAY':
        return [workdayColor, blackFont];
      case 'NON_WORKDAY':
        return [nonWorkdayColor, blackFont];
      default:
        return [undefined, undefined];
    }
  }, [dayStatus]);

  const selectionProps: TableCellProps = useMemo(() => {
    let borderWidth = 1;
    let borderColor = defaultBorderColor;
    if (
      selectedDays.some(
        (sd) =>
          isSameDay(sd.date, day) &&
          sd.employee_id === (employee.id as unknown as number),
      )
    ) {
      borderWidth = 2;
      borderColor = '#111111';
    }
    return {
      borderWidth,
      borderColor,
    };
  }, [employee, day, selectedDays]);

  return (
    <Td
      backgroundColor={backgroundColor}
      color={color}
      userSelect="none"
      p={0}
      h={5}
      w={40}
      {...selectionProps}
      onClick={(e) => {
        selectDay(employee, day, e.ctrlKey, e.shiftKey);
      }}
      cursor="pointer"
      style={{
        textAlign: 'center',
      }}
    >
      {name}
    </Td>
  );
};
